import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "../index.css";
// Initialise i18n (English bundled synchronously; Māori lazy-loaded on toggle)
import "@/i18n/i18n";
import App from "./App.tsx";
import { ThemeProvider } from "./theme/ThemeContext";
import { LanguageProvider } from "./language/LanguageContext";

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
            <ThemeProvider>
                <LanguageProvider>
                    <App />
                </LanguageProvider>
            </ThemeProvider>
        </BrowserRouter>
    </StrictMode>,
);
